import React, { Component } from "react";
import FullCalendar from '@fullcalendar/react'
import { formatDate } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
//import { INITIAL_EVENTS, createEventId } from '../event'
import './month.css'
class MonthCalendar extends Component {
    state = {
        weekendsVisible: true,
    }
    render() {
        const { upcomingEventsList, events, numEvents } = this.props;
        return (
            <div className='cldtd_calendar_card'>

                <div className='cldtd_calendar_card_main'>
                    <FullCalendar
                        plugins={[dayGridPlugin]}
                        headerToolbar={{
                            left: '',
                            center: 'title',
                            right: ''
                        }}
                        displayEventTime={true}
                        initialView='dayGridMonth'
                        events={events}
                        eventColor="#D1A273"
                        eventDisplay='background'
                    />
                </div>
                {this.renderSidebar()}
            </div>
        )
    }
    getVisibleRange() {
        const events = this.props.upcomingEventsList;
        if (!events || events.length === 0) return undefined;
        const dates = events.map(e => new Date(e.start));
        const minDate = new Date(Math.min(...dates));
        const maxDate = new Date(Math.max(...dates));
        maxDate.setDate(maxDate.getDate() + 1);
        return {
            start: minDate.toISOString().split('T')[0],
            end: maxDate.toISOString().split('T')[0]
        };
    }
    renderSidebar() {
        console.log("upcomingEventsList:", JSON.stringify(this.props.upcomingEventsList));
        const visibleRange = this.getVisibleRange();
        return (
            <div className='cldtd_calendar_card_sidebar'>
                <div className='cldtd_calendar_card_sidebar_section'>
                    <div className="cldtd_calendar_card_sidebar_date">Upcoming Events</div>
                    <div className="cldtd_calendar_card_eventSection">
                        <FullCalendar
                            plugins={[listPlugin]}
                            headerToolbar={{
                                left: '',
                                center: '',
                                right: ''
                            }}
                            initialView='list'
                            timeZone='local'
                            dayMaxEventRows={1}
                            events={this.props.upcomingEventsList}
                            visibleRange={visibleRange}
                        />
                    </div>

                </div>
            </div>
        )
    }
}


export default MonthCalendar

